import Command from './_Command';

export default class TitleOnlyButtonController extends Command {
  constructor (
    private readonly key: string, 
    private readonly title: string,
    private readonly path: string | false,
    private readonly openContextMenu?: boolean
  ) {

    super({
      'Enabled': true,
      'Key': key,
      'Text': title,
      'Path': path,
      'OpenContextMenu': openContextMenu,
      'Callback': () => {
        return;
      }
    });
  }
}
